import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class TransactionsCountWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  transactions(type) {
    this.props.history.push({
      pathname: "/artwork",
      state: { type: type },
    });
  }

  render() {
    let closed = 0;
    let inprogress = 0;
    let paused = 0;
    let draft = 0;
    let cancelled = 0;
    let total = 0;

    //show transactions count
    if (this.props.countTransactions) {
      closed = this.props.countTransactions.COMPLETED
        ? this.props.countTransactions.COMPLETED.length
        : 0;

      inprogress = this.props.countTransactions.INPROGRESS
        ? this.props.countTransactions.INPROGRESS.length
        : 0;

      paused = this.props.countTransactions.PAUSED
        ? this.props.countTransactions.PAUSED.length
        : 0;

      draft = this.props.countTransactions.DRAFT
        ? this.props.countTransactions.DRAFT.length
        : 0;

      cancelled = this.props.countTransactions.CANCELED
        ? this.props.countTransactions.CANCELED.length
        : 0;

      total = closed + inprogress + paused + draft + cancelled;
    }

    const optionsPie = {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 0,
        },
        width: "250",
        height: "200",
      },
      colors: ["#009912", "#0098e9", "#4d5f6b", "#005582", "#b5ac9e"],
      title: {
        text: "",
      },
      plotOptions: {
        pie: {
          innerSize: 90,
          depth: 150,
          size: "100%",
          borderColor: "transparent",
        },
        series: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          data: [
            ["Closed", closed],
            ["In Progress", inprogress],
            ["Paused", paused],
            ["Drafts", draft],
            ["Cancelled", cancelled],
          ],
        },
      ],
      tooltip: {
        formatter: function() {
          return "<b>" + this.key + " : " + this.y + "</b>";
        },
      },
    };

    if (total !== 0) {
      return (
        <div>
          <div className="dash-col-head with-border trans-pie-head">
            <h4 className="color-blue-3 font-16 font-600 mb-0">Transactions</h4>
          </div>
          <div className="high-pie">
            <div className="high-pie-count goal-count text-center" />
            <HighchartsReact highcharts={Highcharts} options={optionsPie} />
          </div>
          <div className="high-pie-count text-center d-blue">
            <h4>{total < 10 && total !== 0 ? 0 + "" + total : total}</h4>
            <p>Total</p>
          </div>
          <hr className="my-2" />
          <div className="high-pie-count-row">
            <div
              className="high-pie-count text-center green"
              onClick={() => this.transactions("COMPLETED")}
            >
              <h4>{closed < 10 && closed !== 0 ? 0 + "" + closed : closed}</h4>
              <p>Completed</p>
            </div>
            <div
              className="high-pie-count text-center blue"
              onClick={() => this.transactions("INPROGRESS")}
            >
              <h4>
                {inprogress < 10 && inprogress !== 0
                  ? 0 + "" + inprogress
                  : inprogress}
              </h4>
              <p>In Progress</p>
            </div>
            <div
              className="high-pie-count text-center paused"
              onClick={() => this.transactions("PAUSED")}
            >
              <h4>{paused < 10 && paused !== 0 ? 0 + "" + paused : paused}</h4>
              <p>Paused</p>
            </div>
            <div
              className="high-pie-count text-center scheduled"
              onClick={() => this.transactions("DRAFT")}
            >
              <h4>{draft < 10 && draft !== 0 ? 0 + "" + draft : draft}</h4>
              <p>Drafts</p>
            </div>
            <div
              className="high-pie-count text-center cancel"
              onClick={() => this.transactions("CANCELED")}
            >
              <h4>
                {cancelled < 10 && cancelled !== 0
                  ? 0 + "" + cancelled
                  : cancelled}
              </h4>
              <p>Cancelled</p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="dash-col-head with-border trans-pie-head">
            <h4 className="color-blue-3 font-16 font-600 mb-0">Transactions</h4>
          </div>
          <div className="dash-no-records">No Records Found</div>
        </div>
      );
    }
  }
}

export default TransactionsCountWidget;
